<template>
  <div
    class="styleFormChoice"
    role="radiogroup"
    :aria-label="ariaLabel"
  >
    <button
      v-for="option in options"
      :key="String(option.value)"
      type="button"
      class="styleFormChoice__btn"
      :class="{ 'styleFormChoice__btn--active': isActive(option.value) }"
      :disabled="disabled"
      @click="select(option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'StyleFormChoice',
  props: {
    value: { type: [String, Number, Boolean], default: '' },
    options: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    ariaLabel: { type: String, default: '请选择' },
  },
  methods: {
    isActive(optionValue) {
      return String(this.value) === String(optionValue)
    },
    select(optionValue) {
      if (this.disabled || this.isActive(optionValue)) {
        return
      }
      this.$emit('input', optionValue)
      this.$emit('change', optionValue)
    },
  },
}
</script>

<style scoped>
.styleFormChoice {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(108px, 1fr));
  gap: 8px;
  width: 100%;
}

.styleFormChoice__btn {
  margin: 0;
  padding: 10px 14px;
  border: 1px solid var(--link-line-strong, #e5dfd6);
  border-radius: 10px;
  background: var(--link-field-bg, #f3f0ea);
  color: var(--link-ink-secondary, #4a4541);
  font-family: var(--link-font-family);
  font-size: var(--link-text-sm, 12px);
  font-weight: var(--link-font-medium, 500);
  line-height: 1.35;
  text-align: center;
  cursor: pointer;
  transition:
    border-color 0.15s ease,
    background-color 0.15s ease,
    color 0.15s ease,
    box-shadow 0.15s ease;
}

.styleFormChoice__btn:hover:not(:disabled) {
  border-color: var(--link-ink-faint, #d6d3d1);
  color: var(--link-ink);
}

.styleFormChoice__btn--active {
  border-color: var(--link-accent-border, #cce5ff);
  background: var(--link-accent-bg, #f0f7ff);
  color: var(--link-accent);
  font-weight: var(--link-font-semibold, 600);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.35);
}

.styleFormChoice__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.styleFormChoice__btn:focus-visible {
  outline: 2px solid var(--link-accent);
  outline-offset: 1px;
}
</style>
